async function getCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  return res.json();
}

function hasTriggerItem(cart, triggerHandle) {
  return cart.items.some((item) => item.handle === triggerHandle);
}

function hasAnyOtherItem(cart, triggerHandle) {
  return cart.items.some((item) => item.handle !== triggerHandle);
}

function updateProgress(cart) {
  const root = document.querySelector('#magazine-progress');
  if (!root) return;

  const triggerHandle = root.dataset.triggerHandle;
  const fill = root.querySelector('.magazine-progress__fill');
  const text = root.querySelector('.magazine-progress__text');

  if (!fill || !text) return;

  const hasTrigger = hasTriggerItem(cart, triggerHandle);
  const hasOther = hasAnyOtherItem(cart, triggerHandle);

  if (!hasTrigger) {
    fill.style.width = '0%';
    text.textContent = 'add the praying rug edit to start unlocking your magazine.';
    return;
  }

  if (hasTrigger && !hasOther) {
    fill.style.width = '55%';
    text.textContent = 'so close, the holy edit magazine can’t be missed.';
    return;
  }

  fill.style.width = '100%';
  text.textContent = 'added. it’s now part of ur collection.';
}

async function refreshProgress() {
  try {
    const cart = await getCart();
    updateProgress(cart);
  } catch (e) {}
}

// initial
document.addEventListener('DOMContentLoaded', refreshProgress);

// when drawer updates (minimog/foxkit often triggers cart updates)
document.addEventListener('cart:refresh', refreshProgress);
document.addEventListener('cart:updated', refreshProgress);

// fallback: whenever user clicks add-to-cart / qty buttons
document.addEventListener('click', (e) => {
  const el = e.target.closest('button, a');
  if (!el) return;
  setTimeout(refreshProgress, 600);
});
